module.exports = __webpack_public_path__ + "img/chengguozh3.62127293.webp";